let CP_SCRAMBLE_PII = false;
const cpScramblePIIChangeEvent = new Event("cpScramblePIIChange");

Object.defineProperty(window, "CP_SCRAMBLE_PII", {
  get: function () {
    return CP_SCRAMBLE_PII;
  },
  set: function (value) {
    CP_SCRAMBLE_PII = value;
    window.dispatchEvent(cpScramblePIIChangeEvent);
  },
});
